export const LOCATION_TITLE = "Location";
export const ROOMS_AND_BED_TITLE = "Rooms & beds";
export const AMENITIES_TITLE = "Popular Amenities";
export const AMENITIES_SUBTITLE =
  "Enjoy your luxury stay with some of these popular amenities.";
export const HOUSE_RULES_TITLE = "House rules";
